/** @type {any} */
const win = window;

win.dataLayer = win.dataLayer || [];

// Bridge: receives events pushed from the Shopify Web Pixel sandbox
// (checkout + product/collection/cart events that only exist as
// Customer Events) and forwards them into the REAL dataLayer that
// GTM actually reads on this window.
//
// NOTE: this accepts messages from any origin. If you want to lock
// this down, restrict e.origin to your pixel sandbox's origin
// (check the Network tab on checkout to find the exact origin Shopify
// uses for your account, it can vary).
window.addEventListener("message", function (e) {
  if (!e.data || e.data.type !== "ga4_pixel_event" || !e.data.payload) return;
  win.dataLayer.push(e.data.payload);
});

/** @type {any} */
var GA4_CONTEXT = win.GA4_CONTEXT || {};

var LIST_CONTEXT_KEY = "ga4_last_list_context";
var PRODUCT_CATEGORIES_KEY = "ga4_product_categories";

/**
 * @param {string} productId
 * @param {any} categories
 */
function cacheProductCategories(productId, categories) {
  if (!productId) return;
  try {
    var raw = sessionStorage.getItem(PRODUCT_CATEGORIES_KEY);
    var map = raw ? JSON.parse(raw) : {};
    map[productId] = categories;
    sessionStorage.setItem(PRODUCT_CATEGORIES_KEY, JSON.stringify(map));
  } catch (e) {}
}

/** @param {string} productId */
function getCachedCategories(productId) {
  if (!productId) return null;
  try {
    var raw = sessionStorage.getItem(PRODUCT_CATEGORIES_KEY);
    var map = raw ? JSON.parse(raw) : {};
    return map[productId] || null;
  } catch (e) {
    return null;
  }
}

/** @param {any} context */
function saveListContext(context) {
  try {
    sessionStorage.setItem(LIST_CONTEXT_KEY, JSON.stringify(context));
  } catch (e) {}
}

function getListContext() {
  try {
    var raw = sessionStorage.getItem(LIST_CONTEXT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

/** @param {any} cart */
function getCartCoupon(cart) {
  var codes = (cart.discount_codes || [])
    .filter(/** @param {any} d */ function (d) { return d.applicable; })
    .map(/** @param {any} d */ function (d) { return d.code; });
  return codes.length ? codes.join(", ") : undefined;
}

// ---- view_cart — fires on cart drawer open ----

document.addEventListener("dialog:open", function (event) {
  var target = /** @type {HTMLElement} */ (event.target);
  if (!target || target.tagName.toLowerCase() !== "cart-drawer-component") return;

  fetch("/cart.js")
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var total = cart.total_price / 100;
      var currency = cart.currency;
      var items = (cart.items || []).map(/** @param {any} line @param {any} i */ function (line, i) {
        var cached = getCachedCategories(line.product_id.toString()) || {};
        /** @type {any} */
        var item = {
          item_id: line.product_id.toString(),
          item_name: line.product_title,
          item_brand: line.vendor,
          item_variant: line.variant_title,
          price: line.price / 100,
          quantity: line.quantity,
          index: i
        };
        if (GA4_CONTEXT.affiliation) item.affiliation = GA4_CONTEXT.affiliation;
        if (line.total_discount) item.discount = line.total_discount / 100;
        if (cached.item_category) item.item_category = cached.item_category;
        if (cached.item_category2) item.item_category2 = cached.item_category2;
        if (cached.item_category3) item.item_category3 = cached.item_category3;
        if (cached.item_category4) item.item_category4 = cached.item_category4;
        if (cached.item_category5) item.item_category5 = cached.item_category5;
        return item;
      });
      win.dataLayer.push({
        event: "view_cart",
        ecommerce: { currency: currency, value: total, items: items }
      });
    });
}, { capture: true });

// ---- remove_from_cart — no standard Shopify customer event exists,
// so this is computed here on the theme side by diffing cart state ----

/** @type {any} */
var previousCart = null;

fetch("/cart.js")
  .then(function (r) { return r.json(); })
  .then(function (cart) { previousCart = cart; });

document.addEventListener("cart:update", /** @type {EventListener} */ (function (event) {
  var detail = /** @type {CustomEvent} */ (event).detail || {};
  var data = detail.data || {};
  var cart = detail.resource;

  if (!cart || !cart.items) return;

  if (data.source === "cart-items-component") {
    handleCartLineChange(cart);
  }

  previousCart = cart;
}));

/** @param {any} cart */
function handleCartLineChange(cart) {
  if (!previousCart) return;
  var coupon = getCartCoupon(cart);

  previousCart.items.forEach(/** @param {any} oldItem */ function (oldItem) {
    var newItem = cart.items.find(/** @param {any} i */ function (i) {
      return i.key === oldItem.key;
    });

    var removedQty = oldItem.quantity - (newItem ? newItem.quantity : 0);
    if (removedQty <= 0) return;

    var cached = getCachedCategories(oldItem.product_id.toString()) || {};

    /** @type {any} */
    var item = {
      item_id: oldItem.product_id.toString(),
      item_name: oldItem.product_title,
      item_brand: oldItem.vendor,
      item_variant: oldItem.variant_title,
      price: oldItem.price / 100,
      quantity: removedQty
    };

    if (GA4_CONTEXT.affiliation) item.affiliation = GA4_CONTEXT.affiliation;
    if (oldItem.total_discount) item.discount = oldItem.total_discount / 100;
    if (cached.item_category) item.item_category = cached.item_category;
    if (cached.item_category2) item.item_category2 = cached.item_category2;
    if (cached.item_category3) item.item_category3 = cached.item_category3;
    if (cached.item_category4) item.item_category4 = cached.item_category4;
    if (cached.item_category5) item.item_category5 = cached.item_category5;

    /** @type {any} */
    var removeEcommerce = {
      currency: cart.currency,
      value: (oldItem.price / 100) * removedQty,
      items: [item]
    };
    if (coupon) removeEcommerce.coupon = coupon;
    win.dataLayer.push({ event: "remove_from_cart", ecommerce: removeEcommerce });
  });
}

// ---- select_item — click on product card ----

document.addEventListener("click", function (event) {
  var target = /** @type {HTMLElement} */ (event.target);
  if (!target) return;
  var card = /** @type {Element} */ (target.closest("product-card[data-product-id]"));
  if (!card) return;

  var listItem = target.closest("li[data-ga4-index]");
  var listId = listItem ? listItem.getAttribute("data-ga4-list-id") : null;
  var listName = listItem ? listItem.getAttribute("data-ga4-list-name") : null;
  var index = listItem ? Number(listItem.getAttribute("data-ga4-index")) : undefined;

  /** @type {any} */
  var item = {
    item_id: card.getAttribute("data-product-id"),
    item_name: card.getAttribute("data-ga4-item-name"),
    item_brand: card.getAttribute("data-ga4-item-brand"),
    item_category: card.getAttribute("data-ga4-item-category"),
    item_variant: card.getAttribute("data-ga4-item-variant"),
    price: Number(card.getAttribute("data-ga4-price")) || undefined,
    quantity: 1
  };

  if (GA4_CONTEXT.affiliation) item.affiliation = GA4_CONTEXT.affiliation;
  if (typeof index === "number" && !isNaN(index)) item.index = index;
  if (listId) item.item_list_id = listId;
  if (listName) item.item_list_name = listName;

  var discount = card.getAttribute("data-ga4-discount");
  if (discount) item.discount = Number(discount);

  ["category2", "category3", "category4", "category5"].forEach(function (suffix) {
    var value = card.getAttribute("data-ga4-item-" + suffix);
    if (value) item["item_" + suffix] = value;
  });

  var productId = card.getAttribute("data-product-id");
  if (productId) {
    cacheProductCategories(productId, {
      item_category: item.item_category,
      item_category2: item.item_category2,
      item_category3: item.item_category3,
      item_category4: item.item_category4,
      item_category5: item.item_category5
    });
  }

  /** @type {any} */
  var selectEcommerce = { items: [item] };
  if (listId) selectEcommerce.item_list_id = listId;
  if (listName) selectEcommerce.item_list_name = listName;
  win.dataLayer.push({ event: "select_item", ecommerce: selectEcommerce });

  saveListContext({
    item_list_id: listId,
    item_list_name: listName,
    index: typeof index === "number" && !isNaN(index) ? index : undefined
  });
});

// ---- select_promotion / view_promotion — data-ga4-promotion-* attrs ----

/** @param {Element} element */
function readPromotionPayload(element) {
  /** @type {any} */
  var ecommerce = {
    promotion_id: element.getAttribute("data-ga4-promotion-id"),
    promotion_name: element.getAttribute("data-ga4-promotion-name")
  };
  var creativeName = element.getAttribute("data-ga4-creative-name");
  var creativeSlot = element.getAttribute("data-ga4-creative-slot");
  if (creativeName) ecommerce.creative_name = creativeName;
  if (creativeSlot) ecommerce.creative_slot = creativeSlot;

  /** @type {any} */
  var item = {};
  /** @type {any} */
  var attrMap = {
    "data-ga4-item-id": "item_id",
    "data-ga4-item-name": "item_name",
    "data-ga4-item-brand": "item_brand",
    "data-ga4-item-category": "item_category",
    "data-ga4-item-category2": "item_category2",
    "data-ga4-item-category3": "item_category3",
    "data-ga4-item-category4": "item_category4",
    "data-ga4-item-category5": "item_category5",
    "data-ga4-item-variant": "item_variant",
    "data-ga4-item-list-id": "item_list_id",
    "data-ga4-item-list-name": "item_list_name"
  };
  Object.keys(attrMap).forEach(function (attr) {
    var val = element.getAttribute(attr);
    if (val) item[attrMap[attr]] = val;
  });

  var price = element.getAttribute("data-ga4-price");
  if (price) item.price = Number(price);
  var idx = element.getAttribute("data-ga4-index");
  if (idx) item.index = Number(idx);
  var qty = element.getAttribute("data-ga4-quantity");
  item.quantity = qty ? Number(qty) : 1;

  if (ecommerce.promotion_id) item.promotion_id = ecommerce.promotion_id;
  if (ecommerce.promotion_name) item.promotion_name = ecommerce.promotion_name;
  if (creativeName) item.creative_name = creativeName;
  if (creativeSlot) item.creative_slot = creativeSlot;
  if (GA4_CONTEXT.affiliation) item.affiliation = GA4_CONTEXT.affiliation;

  ecommerce.items = [item];
  return ecommerce;
}

document.addEventListener("click", function (event) {
  var target = /** @type {HTMLElement} */ (event.target);
  if (!target) return;
  var promo = target.closest("[data-ga4-promotion-id]");
  if (!promo) return;
  win.dataLayer.push({ event: "select_promotion", ecommerce: readPromotionPayload(promo) });
});

document.addEventListener("DOMContentLoaded", function () {
  var promos = document.querySelectorAll("[data-ga4-promotion-id]");
  if (!promos.length || typeof IntersectionObserver === "undefined") return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.getAttribute("data-ga4-viewed") === "true") return;
      el.setAttribute("data-ga4-viewed", "true");
      win.dataLayer.push({ event: "view_promotion", ecommerce: readPromotionPayload(el) });
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });

  promos.forEach(function (promo) { observer.observe(promo); });
});